import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'core-switch',
  imports: [],
  standalone: true,
  templateUrl: './switch.html',
  styleUrl: './switch.scss',
  host: {
    style: 'display: inline-flex;algin-items: center;cursor: pointer;'
  }
})
export class Switch {
  @Input() checked = false;
  @Input() disabled = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(event: Event) {
    if (this.disabled) {
      return;
    }
    const input = event.target as HTMLInputElement;
    this.checked = input.checked;
    this.checkedChange.emit(this.checked);
  }
}
